export default {
  apiKey: "AIzaSyDgUkmIcCbIPd2qruYsZMyZUUZH9YYff5E",
  authDomain: "gpt-mx.firebaseapp.com",
  databaseURL: "https://gpt-mx.firebaseio.com",
  projectId: "gpt-mx",
  storageBucket: "gpt-mx.appspot.com",
  messagingSenderId: "908888967138",
  appId: "1:908888967138:web:80e9171ef5f040c51b9bbb",
};
